// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3v-Nl","colCheckbox":"styles_colCheckbox__1XRG9"};